export default __webpack_public_path__ + "static/media/seongdong-self.ef43ec28.jpg";